import LockerCreateContainer from "./LockerCreateContainer"


const LockerCreate = () => {
  return (
    <div className='page-body'>
      <LockerCreateContainer />
    </div>
  )
}

export default LockerCreate